import ChapterBlock from './ChapterBlock';

export default ChapterBlock;
